import * as React from 'react';
import {Link} from 'gatsby';

import * as styles from './cta.module.scss';

interface CTAProps {
  theme: 'primary' | 'secondary';
  size: 'medium' | 'large';
  text: string;
  link: string;
}

const CTA = ({theme, size, text, link}: CTAProps) => {
  const isInternalLink = /^\/(?!\/)/.test(link);

  return (
    <span className={[styles.wrapper, styles[size]].join(' ')}>
      {isInternalLink ? (
        <Link to={link} className={[styles.link, styles[theme]].join(' ')}>
          {text}
        </Link>
      ) : (
        <a
          href={link}
          className={[styles.link, styles[theme]].join(' ')}
          target="_blank"
          rel="noopener noreferrer">
          {text}
        </a>
      )}
    </span>
  );
};

export default CTA;
